import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.object.assign";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmCityList from 'vue-baidu-map/components/controls/CityList.vue';
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue';
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import BmLabel from 'vue-baidu-map/components/overlays/Label.vue';
import { maintain_list } from '@/api/pests';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      defaultList: [],
      maintainList: [],
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 3,
      BMap: null,
      position: {
        lng: 0,
        lat: 0
      },
      uploadList: [],
      refName: 'refName',
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      fileName: 'image',
      fileData: {
        client_id: ""
      },
      format: ['jpg', 'jpeg', 'png'],
      visible: false,
      imgName: '',
      uploadData: {
        client_id: null
      },
      uploadHeaders: {
        "Authorization": getToken()
      },
      proAttrFile: {},
      maintainTag: [],
      formModel: {
        project_name: null,
        //项目名称
        customer_user: null,
        //客户负责人
        tel: null,
        //联系电话
        contract_no: null,
        //合同编号
        contract_start: null,
        //合同开始日期
        contract_end: null,
        //合同结束日期
        maintain_cycle_day: null,
        contract_time: [],
        //合同时间
        maintain_uid: [],
        //维保人员的uid组成的数组
        maintain_start: null,
        //维保开始日期
        lng: null,
        //lng
        lat: null,
        //lat
        center: null,
        address: null,
        //详细地址
        project_pic_path: null //影像图的file_path

      },
      formRules: {
        project_name: [{
          required: true,
          message: '项目名称不能为空',
          trigger: 'change'
        }],
        customer_user: [{
          required: true,
          message: '客户负责人不能为空',
          trigger: 'change'
        }],
        tel: [{
          required: true,
          message: '联系电话不能为空',
          trigger: 'change'
        }, {
          pattern: /^1[3456789]\d{9}$/,
          message: '联系电话格式不正确',
          trigger: 'change'
        }],
        contract_no: [{
          required: true,
          message: '合同编号不能为空',
          trigger: 'change'
        }],
        contract_time: [{
          required: true,
          type: 'array',
          message: '合同时间不能为空',
          trigger: 'change'
        }],
        maintain_uid: [{
          required: true,
          type: 'array',
          message: '维保人员不能为空',
          trigger: 'change'
        }],
        maintain_start: [{
          required: true,
          type: 'date',
          message: '维保开始日期不能为空',
          trigger: 'change'
        }],
        lng: [{
          required: true,
          type: 'number',
          message: '地图标注不能为空',
          trigger: 'change'
        }],
        center: [{
          required: true,
          message: '经纬度不能为空',
          trigger: 'change'
        }],
        address: [{
          required: true,
          message: '详细地址不能为空',
          trigger: 'change'
        }],
        project_pic_path: [{
          required: true,
          message: '影像图不能为空',
          trigger: 'change'
        }],
        maintain_cycle_day: [{
          required: true,
          type: 'number',
          message: '维保周期不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {}
  },
  components: {
    BaiduMap: BaiduMap,
    BmGeolocation: BmGeolocation,
    BmCityList: BmCityList,
    BmMarker: BmMarker,
    BmLabel: BmLabel
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    }
  },
  methods: (_methods = {
    handleView: function handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleMaxSize: function handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '请上传小于4M的图片'
      });
    },
    handleBeforeUpload: function handleBeforeUpload() {
      return true;
    },

    /**
     * 维保开始日期
     */
    startChange: function startChange(val) {
      this.$set(this.formModel, 'maintain_start', val);
    },

    /**
     * 合同开始日期
     */
    contractTimeChange: function contractTimeChange(arr) {
      this.$set(this.formModel, 'contract_start', arr[0]);
      this.$set(this.formModel, 'contract_end', arr[1]);
    },
    handler: function handler(_ref) {
      var BMap = _ref.BMap,
          map = _ref.map;
      this.zoom = 12;

      var _this = this;

      if (this.setData) {
        _this.$set(_this.center, 'lng', this.formModel.lng);

        _this.$set(_this.center, 'lat', this.formModel.lat);
      } else {
        var geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function (r) {
          _this.center = {
            lng: r.longitude,
            lat: r.latitude
          };

          _this.$set(_this.center, 'lng', r.longitude);

          _this.$set(_this.center, 'lat', r.latitude);

          _this.initLocation = true;
        });
      }

      _this.BMap = BMap;
    },

    /**
     * 根据点位获取地理位置
     */
    getLocationAddr: function getLocationAddr(point) {
      var _this = this;

      var gc = new this.BMap.Geocoder();
      gc.getLocation(point, function (rs) {
        console.log(rs);

        if (rs) {
          _this.$set(_this.formModel, 'address', rs.address);
        }
      });
    },
    getLatLng: function getLatLng(point) {
      this.$set(this.formModel, 'lat', point.lat);
      this.$set(this.formModel, 'lng', point.lng);
      this.$set(this.formModel, 'center', point.lng + ',' + point.lat);
    },

    /**
     * 地图点击事件
     */
    mapClick: function mapClick(_ref2) {
      var type = _ref2.type,
          target = _ref2.target,
          point = _ref2.point,
          pixel = _ref2.pixel,
          overlay = _ref2.overlay;
      console.log({
        type: type,
        target: target,
        point: point,
        pixel: pixel,
        overlay: overlay
      });
      this.$set(this, 'position', point);
      console.log(this.position);
      this.getLocationAddr(this.position);
      this.getLatLng(point);
    },
    //检查图片的width和height
    checkImageWH: function checkImageWH(file, width, height) {
      var self = this._vm;
      return new Promise(function (resolve, reject) {
        var filereader = new FileReader();

        filereader.onload = function (e) {
          var src = e.target.result;
          var image = new Image();

          image.onload = function () {
            if (width && this.width != width) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleWidth') + width
              });
              reject();
              self.spinShow = false;
            } else if (height && this.height != height) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleHeight') + height
              });
              reject();
              self.spinShow = false;
            } else {
              resolve();
            }
          };

          image.onerror = reject;
          image.src = src;
        };

        filereader.readAsDataURL(file);
      });
    },

    /**
     * 上传之前检查width,height
     */
    handleUploadImg: function handleUploadImg(file, width, height) {
      return this.checkImageWH(file, width, height);
    }
  }, _defineProperty(_methods, "handleRemove", function handleRemove(file, fileList, str) {
    this.$set(this.formModel, 'company_avatar', '');
    this.uploadList.splice(0);
  }), _defineProperty(_methods, "handleSuccess", function handleSuccess(res, file, str) {
    var vm = this;

    if (res.result === 0) {
      //to do
      this.$set(this.formModel, 'project_pic_path', res.body.file_path);
      this.uploadList.push({
        status: 'finished',
        url: res.body.file_path,
        name: file.name
      });
    } else {
      //删除上传的对象
      this.$Message.error(res.errorMsg);
    }
  }), _defineProperty(_methods, "clientChange", function clientChange(val) {
    this.$set(this.fileData, 'client_id', val);
    this.hasDisabled = false;
  }), _defineProperty(_methods, "handleView", function handleView(name) {
    this.imgName = name;
    this.visible = true;
  }), _defineProperty(_methods, "handleFormatError", function handleFormatError(file) {
    this.$Notice.warning({
      title: '文件格式错误',
      desc: '请上传' + this.format.join(', ') + '类型文件'
    });
  }), _defineProperty(_methods, "init", function init() {
    var _this2 = this;

    this.maintainTag.splice(0);
    maintain_list({
      page: 0,
      page_size: 15
    }).then(function (res) {
      if (res.result === 0) {
        _this2.maintainList = res.body.list || [];

        for (var i in _this2.formModel.maintain_uid) {
          var list = _this2.formModel.maintain_uid[i];

          for (var j = 0; j < _this2.maintainList.length; j++) {
            var item = _this2.maintainList[i];

            if (list === item.uid) {
              _this2.maintainTag.push(item.name);

              break;
            }
          }
        }
      }
    });
  }), _defineProperty(_methods, "handleUpload", function handleUpload(file, data) {
    this.uploadList.splice(0);
    return true;
  }), _methods),
  mounted: function mounted() {
    if (this.edit) {
      if (this.setData) {
        Object.assign(this.formModel, this.setData);
        this.uploadList.push({
          status: 'finished',
          url: this.setData.project_pic_path,
          name: this.setData.project_pic_path
        });
        var lng = Number(this.setData.lng);
        var lat = Number(this.setData.lat);
        this.getLatLng({
          lng: lng,
          lat: lat
        });
        this.$set(this, 'position', {
          lng: lng,
          lat: lat
        });
        this.$set(this.formModel, 'lng', lng);
        this.$set(this.formModel, 'lat', lat);
        this.$set(this.formModel, 'contract_start', formatYMD(this.setData.contract_start * 1000));
        this.$set(this.formModel, 'contract_end', formatYMD(this.setData.contract_end * 1000));
        this.$set(this.formModel, 'contract_time', [formatYMD(this.setData.contract_start * 1000), formatYMD(this.setData.contract_end * 1000)]);
        this.$set(this.formModel, 'maintain_start', formatYMD(this.setData.maintain_start * 1000));
      }
    }
  },
  created: function created() {
    this.init();
  }
};